export default "__VITE_ASSET__BNnK8BCl__"